/**
 * Admin Google Analytics source controls.
 */
import { requestJson } from "./apiClient";

export async function listGa4AnalyticsAdminSources() {
  return requestJson("/api/admin/analytics/ga4/sources");
}

export async function runGa4AnalyticsAdminSource(sourceKey) {
  return requestJson(`/api/admin/analytics/ga4/sources/${encodeURIComponent(sourceKey)}/run`, {
    method: "POST",
  });
}

export async function updateGa4AnalyticsAdminSource(sourceKey, payload) {
  return requestJson(`/api/admin/analytics/ga4/sources/${encodeURIComponent(sourceKey)}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export async function getGa4AnalyticsAdminCredentialsStatus() {
  return requestJson("/api/admin/analytics/ga4/credentials");
}

export async function saveGa4AnalyticsAdminCredentials(serviceAccountJson) {
  return requestJson("/api/admin/analytics/ga4/credentials", {
    method: "PUT",
    body: JSON.stringify({ serviceAccountJson }),
  });
}
